import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ignore-time",
  "use": "icon-ignore-time-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ignore-time\">\n<path d=\"M6.99967 0.332031C3.33301 0.332031 0.333008 3.33203 0.333008 6.9987C0.333008 10.6654 3.33301 13.6654 6.99967 13.6654C10.6663 13.6654 13.6663 10.6654 13.6663 6.9987C13.6663 3.33203 10.6663 0.332031 6.99967 0.332031ZM9.79967 9.7987L6.33301 7.66536V3.66536H7.33301V7.13203L10.333 8.93203L9.79967 9.7987Z\" fill=\"#3F5BD6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol